import script from "./FormularioPoliticaCobranca.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioPoliticaCobranca.vue?vue&type=script&setup=true&lang=js"

import "./FormularioPoliticaCobranca.vue?vue&type=style&index=0&id=37ea857f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37ea857f"]])

export default __exports__